import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, LabelList } from "recharts";

// items: [{ name, value, color }]
export function ScoreBars({ items, height = 260, domainMax = 4, layout = "vertical", testId }) {
  const horizontal = layout === "vertical"; // vertical layout => horizontal bars
  return (
    <div style={{ width: "100%", height }} data-testid={testId}>
      <ResponsiveContainer>
        <BarChart data={items} layout={layout} margin={{ top: 6, right: 30, left: 10, bottom: 6 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eef2f6" horizontal={!horizontal} vertical={horizontal} />
          {horizontal ? (
            <>
              <XAxis type="number" domain={[0, domainMax]} tick={{ fontSize: 11, fill: "#94a3b8" }} />
              <YAxis type="category" dataKey="name" width={150} tick={{ fontSize: 12, fill: "#334155" }} />
            </>
          ) : (
            <>
              <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#334155" }} />
              <YAxis domain={[0, domainMax]} tick={{ fontSize: 11, fill: "#94a3b8" }} />
            </>
          )}
          <Tooltip formatter={(v) => Number(v).toFixed(2)} cursor={{ fill: "rgba(0,48,87,0.04)" }} />
          <Bar dataKey="value" radius={horizontal ? [0, 8, 8, 0] : [8, 8, 0, 0]} barSize={26}>
            {items.map((it, i) => (
              <Cell key={i} fill={it.color || "#005291"} />
            ))}
            <LabelList dataKey="value" position={horizontal ? "right" : "top"}
              formatter={(v) => Number(v).toFixed(2)} style={{ fontSize: 11, fill: "#334155", fontWeight: 600 }} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
